<template>
  <div class="w-full text-center">
    <p class="text-gray-500/80 text-sm">
      <a
        v-for="menu in menuStore.authMenu"
        :key="menu.Id"
        :href="menu.Link"
        class="text-primary font-semibold ms-1"
      >
        - {{ menu.Name }}</a
      >
    </p>
  </div>
</template>

<script setup>
import { useMenuStore } from "@/stores/menuStore";

const menuStore = useMenuStore();
</script>
